import { AutogenLayoutSrcQuickInfo } from "./autogen/AutogenLayoutSrcQuickInfo";

export class SrcQuickInfo extends AutogenLayoutSrcQuickInfo {
}
